var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "chevron-down_svg__icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.244a.812.812 0 0 0 .59-.267l4.825-4.938a.723.723 0 0 0 .215-.527.748.748 0 0 0-.749-.756c-.203 0-.4.083-.546.229l-4.329 4.45-4.341-4.45a.79.79 0 0 0-.546-.229.748.748 0 0 0-.75.756c0 .21.077.387.216.527l4.831 4.938c.171.178.362.267.584.267Z",
    fill: "currentColor"
  })));
};

export default SvgChevronDown;